import { render } from "./Registre.vue?vue&type=template&id=4fedac0c"
import script from "./Registre.vue?vue&type=script&lang=js"
export * from "./Registre.vue?vue&type=script&lang=js"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__